import React from "react";

 const Spinner= () =>{
  return (
    <div className="spinner">
  <div className="halfSpin"></div>
</div>
  );
}
export default Spinner